export const ember = {
  50: '#22272b',
  100: '#1c2a3b',
  150: '#1c2a4c',
  200: '#25265c',
  250: '#331f68',
  300: '#441170',
  350: '#611175',
  400: '#800f73',
  450: '#9f096a',
  500: '#bc0758',
  550: '#d7153a',
  600: '#de2b34',
  650: '#e43b2e',
  700: '#e94927',
  750: '#ee5621',
  800: '#f3631b',
  850: '#f77300',
  900: '#f98200',
  950: '#fb9100',
  1000: '#fba000',
  1050: '#faaf05',
}
export const earthfire = {
  50: '#523719',
  100: '#5f360d',
  150: '#6c3300',
  200: '#7a2e00',
  250: '#872600',
  300: '#941b00',
  350: '#a72a05',
  400: '#b9380b',
  450: '#cc4611',
  500: '#e05516',
  550: '#f3631b',
  600: '#f77300',
  650: '#f98200',
  700: '#fb9100',
  750: '#fba000',
  800: '#faaf05',
  850: '#fabb3b',
  900: '#fac757',
  950: '#fbd26f',
  1000: '#fcdd85',
  1050: '#fde79a',
}
export const fuchsiaHeat = {
  50: '#65004d',
  100: '#7b025f',
  150: '#920472',
  200: '#a90885',
  250: '#c10d99',
  300: '#d912ae',
  350: '#e61e92',
  400: '#f02d77',
  450: '#f53e5b',
  500: '#f6503e',
  550: '#f3631b',
  600: '#f77300',
  650: '#f98200',
  700: '#fb9100',
  750: '#fba000',
  800: '#faaf05',
  850: '#fabb3b',
  900: '#fac757',
  950: '#fbd26f',
  1000: '#fcdd85',
  1050: '#fde79a',
}
export const polarGlow = {
  50: '#002664',
  100: '#013380',
  150: '#03419e',
  200: '#074fbd',
  250: '#0d5ddc',
  300: '#146cfd',
  350: '#0077e7',
  400: '#007ed0',
  450: '#0082b8',
  500: '#0082a2',
  550: '#2e808e',
  600: '#42929f',
  650: '#54a3b0',
  700: '#67b6c1',
  750: '#79c8d3',
  800: '#8cdbe5',
  850: '#9adfe5',
  900: '#a9e3e5',
  950: '#b6e7e6',
  1000: '#c4ebe7',
  1050: '#d1eeea',
}
export const glacierPool = {
  50: '#441170',
  100: '#511e88',
  150: '#5d2ba1',
  200: '#6a39bb',
  250: '#7546d6',
  300: '#8055f1',
  350: '#7359f6',
  400: '#645efa',
  450: '#5362fc',
  500: '#3c67fd',
  550: '#146cfd',
  600: '#0089ff',
  650: '#0ca2ff',
  700: '#3bb9ff',
  750: '#64cdff',
  800: '#8ce0ff',
  850: '#9ae3ff',
  900: '#a7e5ff',
  950: '#b3e8fe',
  1000: '#bfeafe',
  1050: '#cbedfd',
}
export const deepCurrent = {
  50: '#0b3f47',
  100: '#124b54',
  150: '#195862',
  200: '#206571',
  250: '#27727f',
  300: '#2e808e',
  350: '#0082a2',
  400: '#0082b8',
  450: '#007ed0',
  500: '#0077e7',
  550: '#146cfd',
  600: '#0089ff',
  650: '#0ca2ff',
  700: '#3bb9ff',
  750: '#64cdff',
  800: '#8ce0ff',
  850: '#9ae3ff',
  900: '#a7e5ff',
  950: '#b3e8fe',
  1000: '#bfeafe',
  1050: '#cbedfd',
}
export const blueRed = {
  50: '#002664',
  100: '#013380',
  150: '#03419e',
  200: '#074fbd',
  250: '#0d5ddc',
  300: '#146cfd',
  350: '#4c8eff',
  400: '#79acff',
  450: '#a5c8ff',
  500: '#d2e4ff',
  550: '#fed7d6',
  600: '#f9afae',
  650: '#f18687',
  700: '#e55961',
  750: '#d7153a',
  800: '#bf0f34',
  850: '#a70a2d',
  900: '#8f0527',
  950: '#790220',
  1000: '#630019',
}
export const blueOrange = {
  50: '#002664',
  100: '#013380',
  150: '#03419e',
  200: '#074fbd',
  250: '#0d5ddc',
  300: '#146cfd',
  350: '#4c8eff',
  400: '#79acff',
  450: '#a5c8ff',
  500: '#d2e4ff',
  550: '#ffe2d6',
  600: '#ffc4ad',
  650: '#fea683',
  700: '#fa8657',
  750: '#f3631b',
  800: '#e05516',
  850: '#cc4611',
  900: '#b9380b',
  950: '#a72a05',
  1000: '#941b00',
}
export const purpleYellow = {
  50: '#441170',
  100: '#511e88',
  150: '#5d2ba1',
  200: '#6a39bb',
  250: '#7546d6',
  300: '#8055f1',
  350: '#967bf7',
  400: '#ae9efb',
  450: '#c7bffe',
  500: '#e3dfff',
  550: '#fff0da',
  600: '#ffe0b4',
  650: '#fed08b',
  700: '#fcc05d',
  750: '#faaf05',
  800: '#db9903',
  850: '#bd8402',
  900: '#a06f01',
  950: '#845b00',
  1000: '#694800',
}
export const fuchsiaTeal = {
  50: '#65004d',
  100: '#7b025f',
  150: '#920472',
  200: '#a90885',
  250: '#c10d99',
  300: '#d912ae',
  350: '#e65bbf',
  400: '#f088cf',
  450: '#f8b1df',
  500: '#fdd8ef',
  550: '#d6e5e8',
  600: '#aecbd1',
  650: '#86b2ba',
  700: '#5d99a4',
  750: '#2e808e',
  800: '#27727f',
  850: '#206571',
  900: '#195862',
  950: '#124b54',
  1000: '#0b3f47',
}
